import { Component, OnInit, ViewChild } from '@angular/core';
import { DialogService, DynamicDialogRef } from 'primeng/dynamicdialog';
import { Table } from 'primeng/table';
import { ParametrosvariablesService, IParametroVariable, IOpcion, IParametrosVariablesRequest } from '@p-parametria/parametros/services/parametrosvariables.service';
import { SwalService } from '@shared/utils/swal.service';
import { ParametrosVariablesFormComponent } from './parametros-variables-form/parametros-variables-form.component';
import { ConfirmDeletionComponent } from '@shared/components/confirm-deletion/confirm-deletion.component';
import Swal from 'sweetalert2';

interface ParametroVariable {
  parametro: string;
  producto: string;
  valor: string;
  descripcion: string;
}

@Component({
  selector: 'app-parametros-variables',
  templateUrl: './parametros-variables.component.html',
  styleUrls: ['./parametros-variables.component.css'],
  providers: [DialogService]
})
export class ParametrosVariablesComponent implements OnInit {
  @ViewChild('dt') table!: Table;
  
  public columns = [
    { field: 'parametro', header: 'Parámetro' },
    { field: 'producto', header: 'Promoción' },
    { field: 'valor', header: 'Valor' },
    { field: 'descripcion', header: 'Descripción' },
    { field: 'actions', header: 'Acciones' }
  ];
  
  public dataSource: IParametroVariable[] = [];
  public listOpciones: IOpcion[] = [];
  public loading: boolean = true;
  private readonly _width: string = '380px';
  ref: DynamicDialogRef;

  constructor(
    private parametrosvariablesService: ParametrosvariablesService,
    private _swalService: SwalService,
    private dialogService: DialogService
  ) {}

  ngOnInit(): void {
    this.loadOpciones();
    this.loadData();
  }

  loadOpciones() {
    this.parametrosvariablesService.GetOpciones().subscribe({
      next: (response) => {
        if (response.success) {
          this.listOpciones = response.data;
        } else {
          this._swalService.error('Error al cargar las opciones');
        }
      },
      error: (error) => {
        console.error('Error al cargar opciones:', error);
        this._swalService.error('Error al cargar las opciones');
      }
    });
  }

  loadData(): void {
    this.loading = true;
    this.parametrosvariablesService.GetParametrosVariables().subscribe({
      next: (response) => {
        if (response.success) {
          this.dataSource = response.data;
        } else {
          console.error('Error al cargar parámetros variables:', response);
          this._swalService.error('Error al cargar los parámetros variables');
        }
        this.loading = false;
      },
      error: (error) => {
        console.error('Error al cargar parámetros variables:', error);
        this._swalService.error('Error al cargar los parámetros variables');
        this.loading = false;
      }
    });
  }

  nuevo(): void {
    this.ref = this.dialogService.open(ParametrosVariablesFormComponent, {
      header: 'Nuevo Parámetro Variable',
      width: '70%',
      contentStyle: { overflow: 'auto' },
      baseZIndex: 10000,
    });

    this.ref.onClose.subscribe((result: boolean) => {
      if (result) {
        this.loadData();
      }
    });
  }

  editar(row: IParametroVariable): void {
    this.ref = this.dialogService.open(ParametrosVariablesFormComponent, {
      header: 'Editar Parámetro Variable',
      width: '70%',
      contentStyle: { overflow: 'auto' },
      baseZIndex: 10000,
      data: row
    });

    this.ref.onClose.subscribe((result: boolean) => {
      if (result) {
        this.loadData();
      }
    });
  }

  delete(model: IParametroVariable) {
    Swal.fire({
      title: '¿Está seguro?',
      text: `¿Está seguro de eliminar el parámetro ${model.parametro}?`,
      icon: 'warning',
      showCancelButton: true,
      iconColor: "#d33",
      confirmButtonColor: "#d33",
      confirmButtonText: 'Sí, eliminar',
      cancelButtonText: 'No',
      heightAuto: false
    }).then((result) => {
      if (result.isConfirmed) {
        const payload: IParametrosVariablesRequest = {
          que: 3,
          tope: "",
          cmd: "",
          parametro: model.parametro,
          promocion: model.producto,
          valor: "",
          descripcion: ""
        };

        this.parametrosvariablesService.ParametrosVariablesDelete(payload).subscribe({
          next: (response) => {
            if (response.success && response.data) {
              this._swalService.success('Eliminado correctamente');
              this.loadData();
            } else {
              this._swalService.error('No se pudo eliminar');
            }
          },
          error: (error) => {
            console.error('Error al eliminar:', error);
            this._swalService.error('Error al eliminar');
          }
        });
      }
    });
  }

  clear(table: Table) {
    table.clear();
  }
}
